<template>
  <svg xmlns:ct="http://gionkunz.github.com/chartist-js/ct" width="100%" height="100%" class="ct-chart-bar"
       style="width: 100%; height: 100%;">
    <g class="ct-grids"></g>
    <g>
      <g class="ct-series ct-series-a">
        <line x1="13.214285714285715" x2="13.214285714285715" y1="62" y2="58.642857142857146" class="ct-bar"
              ct:value="50" style="stroke-width: 2px"></line>
        <line x1="19.642857142857146" x2="19.642857142857146" y1="62" y2="48.57142857142857" class="ct-bar"
              ct:value="200" style="stroke-width: 2px"></line>
        <line x1="26.071428571428573" x2="26.071428571428573" y1="62" y2="51.92857142857143" class="ct-bar"
              ct:value="150" style="stroke-width: 2px"></line>
        <line x1="32.5" x2="32.5" y1="62" y2="35.14285714285714" class="ct-bar" ct:value="400"
              style="stroke-width: 2px"></line>
        <line x1="38.92857142857143" x2="38.92857142857143" y1="62" y2="41.85714285714286" class="ct-bar"
              ct:value="300" style="stroke-width: 2px"></line>
        <line x1="45.35714285714286" x2="45.35714285714286" y1="62" y2="21.714285714285715" class="ct-bar"
              ct:value="600" style="stroke-width: 2px"></line>
        <line x1="51.785714285714285" x2="51.785714285714285" y1="62" y2="15" class="ct-bar" ct:value="700"
              style="stroke-width: 2px"></line>
      </g>
    </g>
    <g class="ct-labels"></g>
  </svg>
</template>

<script>
export default {
  name: "metrics"
}
</script>
